import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";

const Footer = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);
  const { userData } = useContext(AuthContext);


  return (
      <footer className={`footer-policy ${ isUserAuthorized ? "bg-secondary" : "bg-primary"}`}>
      {/* Hub Footer Link Layer */}
      <div className="container-fluid text-uppercase d-flex justify-content-center align-items-center">
        <Link className="text-white text-decoration-none Hub-Footer-link"
          to={userData?.is_password_changed ? (isUserAuthorized ? (isManufacturer ? userData.ref_type === "Manufacturer" ? `/statistics`: `/statistics/${userData.id}` : (userData.baa_viewed ? `/cases` : "/pages/baa")) : `/users/sign_in`) : `/users/createuser`}
        >
          Home
        </Link>
        <a href="https://mannkindcorp.com/privacy-policy/" target="_blank"
           className="text-white text-decoration-none Hub-Footer-link">Privacy Policy</a>
        <Link to = {'/pages/baa'} className="text-white text-decoration-none Hub-Footer-link">
          Legal Disclaimer
        </Link>
        <a href="mailto:suggestions@cmcopilot.com" className="text-white text-decoration-none Hub-Footer-link">
          Suggestions
        </a>
      </div>

      <div style={{ backgroundColor: '#f5f5f5' }}>
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                onClick={changeAccordianVisibility}
                className="accordion-button collapsed px-3 py-1 text-uppercase Hub-Footer-link fw-normal footer-accordian fs-5 "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                PLEASE SEE IMPORTANT SAFETY INFORMATION AND FULL PRESCRIBING INFORMATION
                {isAccordianShown ? (
                  <i className="bi bi-chevron-down ps-1"></i>
                ) : (
                  <i className="bi bi-chevron-up ps-1"></i>
                )}
              </button>
            </h2>
            <div id="collapseOne" className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`} data-bs-parent="#accordionExample">
              <div style={{ backgroundColor: "#f5f5f5", maxHeight: '50vh', overflowY: 'auto' }}>
                <div className="container">
                  <h5 className="text-center text-primary pt-4"><b>PRESCRIBER IMPORTANT SAFETY INFORMATION</b></h5>
                  <h5>Indications and Usage:</h5>
                  <p>AFREZZA® (insulin human) Inhalation Powder is a rapid acting inhaled human
                    insulin indicated to improve glycemic control in adult and pediatric patients 6 years of age and older with diabetes mellitus.
                  </p>

                  <p>
                    <i className="fw-bold fs-5">Limitations of Use: </i>Not recommended for the treatment of diabetic ketoacidosis,
                    not recommended in patients who smoke or have recently stopped smoking.
                  </p>
                  <h5 className="fst-italic text-primary">IMPORTANT SAFETY INFORMATION</h5>

                  <div className="py-3 my-3 border border-dark border-3 rounded">
                    <h5 className="text-center mb-3">WARNING: RISK OF ACUTE BRONCHOSPASM IN PATIENTS WITH CHRONIC LUNG DISEASE</h5>
                    <ul className="fw-bold fs-5">
                      <li>Acute bronchospasm has been observed in AFREZZA-treated patients with asthma and Chronic
                        Obstructive Pulmonary Disease (COPD).
                      </li>
                      <li>
                        AFREZZA is contraindicated in patients with chronic lung disease such as asthma or COPD.
                      </li>
                      <li>
                        Before initiating AFREZZA, perform a detailed medical history, physical examination, and spirometry
                        (FEV1) to identify potential lung disease in all patients.
                      </li>
                    </ul>
                  </div>

                  <h5>Contraindications</h5>
                  <p>
                    AFREZZA is contraindicated: during episodes of hypoglycemia, in patients with chronic lung disease
                    (such as asthma or COPD) because of the risk of acute bronchospasm, and in patients with previous
                    severe hypersensitivity reaction to any regular human insulin product or any of the inactive ingredients
                    in AFREZZA. Severe, life-threatening, generalized allergy, including anaphylaxis, can occur with AFREZZA.
                  </p>

                  <h5>Warnings and Precautions</h5>
                  <p>
                    <i className="fw-bold fs-5">Acute Bronchospasm in patients with chronic lung disease:</i> In a study of patients with asthma whose bronchodilators were temporarily
                    withheld for assessment, bronchoconstriction and wheezing following AFREZZA dosing was reported.
                    Before initiating therapy, evaluate all patients with a medical history, physical examination, and
                    spirometry (FEV1) to identify potential underlying lung disease. Do not use in patients with chronic
                    lung disease such as asthma or COPD.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Hypoglycemia or Hyperglycemia with Changes in Insulin Regimen: </i>
                    Changes in an insulin regimen (e.g., insulin strength, manufacturer, injection site or type, or
                    method of administration) may affect glycemic control and predispose to hypoglycemia or hyperglycemia.
                    If clinically indicated, make any necessary changes to a patient’s insulin regimen under close medical
                    supervision with increased frequency of blood glucose monitoring. For patients with type 2 diabetes,
                    dosage modifications of concomitant oral antidiabetic treatment may be needed.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Hypoglycemia: </i>
                    Hypoglycemia is the most common adverse reaction associated with insulins, including AFREZZA. Severe
                    hypoglycemia can cause seizures, may be life-threatening, or cause death. Hypoglycemia can impair
                    concentration ability and reaction time; this may place an individual and others at risk in situations
                    where these abilities are important (e.g., driving or operating other machinery). Hypoglycemia can
                    happen suddenly, and symptoms may differ across patients and change over time in the same patient.
                    Advise patients to recognize and manage hypoglycemia and self-monitor glucose. In patients at higher
                    risk for hypoglycemia and patients who have reduced symptomatic awareness of hypoglycemia, increased
                    frequency of glucose monitoring is recommended.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Decline in Pulmonary Function: </i>
                    AFREZZA causes a decline in lung pulmonary function over time as measured by FEV1. In clinical trials
                    excluding patients with chronic lung disease and lasting up to 2 years, AFREZZA-treated patients
                    experienced a small (40 mL) but greater FEV1 decline than comparator-treated patients. Assess
                    pulmonary function with spirometry at baseline, after the first 6 months of therapy and annually
                    thereafter even in the absence of pulmonary symptoms. In patients who have a decline of ≥20% in
                    FEV1 from baseline, consider discontinuing AFREZZA. Consider more frequent lung function assessment
                    in patients with pulmonary symptoms, e.g., wheezing, bronchospasm, breathing difficulties, or
                    persistent or recurring cough. If symptoms persist, discontinue AFREZZA.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Lung Cancer: </i>
                    In clinical trials, 2 cases of lung cancer were observed in patients exposed to AFREZZA while no cases
                    were reported for the comparators. In both cases, a prior history of heavy tobacco use was identified
                    as a risk factor for lung cancer. Two additional cases of lung cancer (squamous cell and lung blastoma)
                    were reported in non-smokers exposed to AFREZZA after the trial completion. These data are insufficient
                    to determine whether AFREZZA has an effect on lung or respiratory tract tumors. In patients with active
                    lung cancer, a prior history of lung cancer, or in patients at risk of lung cancer, consider whether
                    the benefits of AFREZZA use outweigh this potential risk.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Diabetic Ketoacidosis (DKA): </i>
                    In clinical trials enrolling patients with type 1 diabetes, diabetic ketoacidosis (DKA) was more
                    common in AFREZZA-treated patients (0.43%; n=13) than in comparator-treated patients (0.14%; n=3).
                    Patients with type 1 diabetes should always use AFREZZA concomitantly with basal insulin. In patients
                    at risk for DKA, such as those with an acute illness or infection, increase the frequency of glucose
                    monitoring and consider discontinuing AFREZZA and giving insulin using an alternate route of administration.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Hypersensitivity Reactions: </i>
                    Severe, life-threatening, generalized allergy, including anaphylaxis, can occur with insulin products.
                    If hypersensitivity reactions occur, discontinue AFREZZA, treat per standard of care and monitor until
                    symptoms and signs resolve.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Hypokalemia: </i>
                    All insulin products, including AFREZZA, cause a shift in potassium from the extracellular to
                    intracellular space, possibly leading to hypokalemia. Untreated hypokalemia may cause respiratory
                    paralysis, ventricular arrhythmia, and death. Closely monitor potassium levels in patients at risk
                    of hypokalemia and treat if indicated.
                  </p>
                  <p>
                    <i className="fw-bold fs-5">Fluid Retention and Heart Failure with Concomitant Use of PPAR-gamma Agonists: </i>
                    Thiazolidinediones (TZDs), which are peroxisome proliferator-activated receptor (PPAR)-gamma agonists,
                    can cause dose-related fluid retention, particularly when used in combination with insulin. Fluid
                    retention may lead to or exacerbate heart failure. Observe these patients for signs and symptoms of
                    heart failure. If heart failure develops, it should be managed according to current standards of
                    care, and discontinuation or dose reduction of the TZD should be considered.
                  </p>

                  <h5>Adverse Reactions</h5>
                  <p>
                    The most common adverse reactions associated with AFREZZA are hypoglycemia, cough, and throat pain or
                    irritation.
                  </p>

                  <h5>Drug Interactions</h5>
                  <p>
                    Certain drugs may affect glucose metabolism, increasing the risk of hypoglycemia, or decreasing or
                    increasing the blood glucose lowering effect of AFREZZA. Dosage modification and increased frequency
                    of blood glucose monitoring may be required. Co-administration of beta-blockers, clonidine,
                    guanethidine, and reserpine with AFREZZA may reduce the signs and symptoms of hypoglycemia. For full
                    list, see Prescribing Information.
                  </p>
                  <p>
                    To report SUSPECTED ADVERSE REACTIONS, contact MannKind Corporation at 1-877-323-8505 or FDA at
                    <a href="https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program" target="_blank"> www.fda.gov/medwatch </a>
                     or call 1-800-FDA-1088 (1-800-332-1088).
                  </p>
                  <p>
                    Please see
                    <a href="https://afrezzahcp.com/wp-content/uploads/2026/01/Full-Prescribing-Information-Jan-2026.pdf" target="_blank"> full Prescribing Information</a>, including BOXED WARNING for AFREZZA.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
